module.exports = __webpack_public_path__ + "img/select.08609eb9.svg";